import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=627d94b6"
import script from "./WaitingList.vue?vue&type=script&lang=js"
export * from "./WaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports